import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
/**
 * Renders a global footer for the application with optional copyright
 * information and a list of footer links.
 *
 * @param {GlobalContentFooterProps} props - Props for the global footer component.
 * @param {string} [props.footerCopyright] - Optional copyright text.
 * @param {{ label: string; href?: string; onClick?: () => void }[]} [props.footerLinks] - Optional list of footer links, each with a label and optional href or click handler.
 *
 * @returns {JSX.Element} The rendered footer with links and optional copyright, hidden during print.
 */
export const GlobalContentFooter = (props) => {
    return (React.createElement(Typography, { component: 'footer', variant: 'caption', sx: {
            pt: 2,
            pb: 2,
            pl: 4,
            pr: 4,
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            flexWrap: 'wrap',
            '@media print': {
                display: 'none',
            },
        } },
        props.footerCopyright && React.createElement(Box, { sx: { color: themeColors.text.subtle } }, props.footerCopyright),
        props.footerLinks &&
            props.footerLinks.length > 0 &&
            props.footerLinks.map(({ label, href, onClick }) => (React.createElement(React.Fragment, { key: label },
                React.createElement(Box, { sx: { color: themeColors.border.main } }, "|"),
                React.createElement(Link, { sx: { textDecoration: 'none', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }, href: href, target: href ? '_blank' : undefined, onClick: onClick
                        ? (event) => {
                            event.preventDefault();
                            onClick();
                        }
                        : undefined }, label))))));
};
